import(/* webpackMode: "eager", webpackExports: ["SpeelMee"] */ "/vercel/path0/apps/klassiekerspel/app/components/speel-mee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tutorial"] */ "/vercel/path0/apps/klassiekerspel/app/components/tutorial.tsx");
